import { initContract } from '@ts-rest/core';
import { z } from 'zod';

import { BatchesCriteriaSchema, BatchListItemSchema } from './schemas';

const c = initContract();

const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const contentType = 'multipart/form-data';

export const batchesCoreContract = c.router({
  listBatches: {
    method: 'POST',
    path: '/batches',
    body: z.object({ criteria: BatchesCriteriaSchema.optional() }),
    responses: {
      200: z.object({
        data: z.object({
          list: z.array(BatchListItemSchema),
          totalItems: z.number(),
        }),
      }),
    },
  },
  addBatch: {
    method: 'POST',
    path: '/batches/add',
    contentType: contentType,
    body: z.object({
      customer: z.string(),
      name: z.string(),
      template: z.string(),
      brokerId: z.string().optional(),
      hvSplittingCustomer: z.string().optional(),
      hvSplittingTemplate: z.string().optional(),
      h7ExcludedCustomer: z.string().optional(),
      h7ExcludedTemplate: z.string().optional(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  bulkUpload: {
    method: 'POST',
    path: '/batches/bulk-upload',
    contentType: contentType,
    body: z.object({
      customer: z.string(),
      name: z.string(),
      template: z.string(),
      brokerId: z.string().optional(),
      hvSplittingCustomer: z.string().optional(),
      hvSplittingTemplate: z.string().optional(),
      h7ExcludedCustomer: z.string().optional(),
      h7ExcludedTemplate: z.string().optional(),
    }),
    responses: {
      200: z.object({ message: z.string() }),
    },
  },
  downloadTraceFile: {
    method: 'POST',
    path: '/batches/download-trace-file',
    body: z.object({
      fileName: z.string(),
      cloudBucketFileName: z.string(),
    }),
    responses: {
      200: c.otherResponse({ contentType: XLSX_CONTENT_TYPE, body: z.unknown() }),
    },
  },
  updateBatch: {
    method: 'POST',
    path: '/batches/:id/update',
    contentType: contentType,
    pathParams: z.object({ id: z.string() }),
    body: z.object({
      customer: z.string(),
      name: z.string(),
      template: z.string(),
    }),
    responses: {
      200: z.object({ data: z.any() }),
    },
  },
  downloadBatch: {
    method: 'POST',
    path: '/batches/:id/download',
    pathParams: z.object({ id: z.string() }),
    body: c.noBody(),
    responses: {
      200: c.otherResponse({ contentType: XLSX_CONTENT_TYPE, body: z.unknown() }),
    },
  },
  getBatch: {
    method: 'GET',
    path: '/batches/:id',
    pathParams: z.object({ id: z.string() }),
    responses: {
      200: z.object({ data: z.object({ batch: BatchListItemSchema }) }),
    },
  },
  deleteBatch: {
    method: 'DELETE',
    path: '/batches/:id',
    pathParams: z.object({ id: z.string() }),
    body: z.object({ softDelete: z.boolean().optional() }),
    responses: {
      200: z.object({}),
    },
  },
});
